'use client'

import { CartItemList } from '@/feature/cart/components/cart-item-list/CartItemList'
import {
  equivalentProductsSlugAtom,
  isEquivalentProductsDrawerOpenAtom,
} from '@/feature/product/services/equivalentProducts.store'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Drawer, DrawerAction, DrawerBody, DrawerFooter } from '@/ui/drawer/drawer/Drawer.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { Loader } from '@/ui/loaders/loader/Loader'
import { gql } from '@gql-generated/gql'
import { useAtom, useAtomValue } from 'jotai'
import { useEffect } from 'react'
import { AddToBasketCard } from '../add-to-basket-card/AddToBasketCard.client'
import { useLazyQuery } from '@apollo/client'
import { EquivalentProductsDrawerDocument } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query EquivalentProductsDrawer($urlKey: String!) {
    product(urlKey: $urlKey) {
      reference
      equivalentProducts {
        ...ProductCard
      }
    }
  }
`)

export function EquivalentProductsDrawer() {
  const [isOpen, setIsOpen] = useAtom(isEquivalentProductsDrawerOpenAtom)
  const slug = useAtomValue(equivalentProductsSlugAtom)
  const [getEquivalentProducts, { data }] = useLazyQuery(EquivalentProductsDrawerDocument)
  const { t } = useTranslation(['equivalentProductsDrawer'])

  const equivalentProducts = data?.product?.equivalentProducts

  useEffect(() => {
    if (slug) {
      getEquivalentProducts({
        variables: { urlKey: slug },
      })
    }
  }, [slug, getEquivalentProducts])

  const handleOpenChange = (nextIsOpen: boolean) => {
    setIsOpen(nextIsOpen)
  }

  return (
    <Drawer
      size="xl"
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      title={t('equivalentProductsDrawer:title')}
    >
      <DrawerBody>
        {!equivalentProducts || equivalentProducts.length === 0 ? (
          <Loader className="justify-self-center" />
        ) : (
          <CartItemList withDividers className="w-full gap-2">
            {equivalentProducts.map((product) => (
              <CartItemList.Item key={product.reference}>
                <AddToBasketCard
                  product={product}
                  onPress={() => {
                    handleOpenChange(false)
                  }}
                />
              </CartItemList.Item>
            ))}
          </CartItemList>
        )}
      </DrawerBody>
      <DrawerFooter>
        <DrawerAction type="cancel" icon={<Icon.ArrowLeft />}>
          {t('equivalentProductsDrawer:continuePurchase')}
        </DrawerAction>
      </DrawerFooter>
    </Drawer>
  )
}
